// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1oY9m","question":"styles_question__32ZLL","description":"styles_description__1v61q"};